import React from 'react';
import Sidebar from '../components/commonComp/Sidebar';
import { Outlet, Link } from "react-router-dom";
import Footer from '../components/commonComp/Footer';
import Header from '../components/commonComp/Header';
import { ToastContainer } from 'react-toastify';
import { useSelector, useDispatch } from 'react-redux'
import 'react-toastify/dist/ReactToastify.css';
import { IntlProvider, FormattedMessage } from "react-intl";
import enMessages from '../utility/language/english.json';
import koMessages from '../utility/language/korean.json';

const Home = () => {
  const languageState = useSelector((state) => state.languageState);
  let languageCode = languageState.active_language.language_code;

  const allMessages = {
    en: enMessages,
    kor: koMessages,
  }

  let messages = allMessages[languageCode]

  return (
    <IntlProvider messages={messages} locale={languageCode} defaultLocale={languageCode} >
      <section className="main">
        <ToastContainer />
        <Sidebar />
        <section className="home">
          <Header />

          <Outlet />
          <Footer className="footer" />
        </section>
      </section>
    </IntlProvider>
  )
}

export default Home
